<div class="notification-box" (click)="toggleNotificationMobile()">
  <app-feather-icons [icon]="'bell'"></app-feather-icons>
  <span class="badge rounded-pill badge-secondary" *ngIf="toastr.notificationscount!='' ">{{toastr.notificationscount}}</span>
</div>
<ul class="notification-dropdown onhover-show-div" [class.active]="openNotification">
  <li>
    <app-feather-icons [icon]="'bell'"></app-feather-icons>
    <h6 class="f-18 mb-0">{{'Notifications'|translate}}</h6>
  </li>
   <ng-container *ngIf="toastr.notifications!=null">
    <li *ngFor="let notification of toastr.notifications" [ngClass]="{'unseen': !notification.isSeen}">
 
      <a (click)="showNotificationData(notification,$event);" class="dropdown-item islink">

        <div class="row">
          <a class="col-md-12 py-2">
            <div style="font-size:12px;white-space: normal; overflow: hidden; font-weight: bold;">{{notification.notificationTitle}}</div>
          </a>
        </div>
      </a>
    </li>
  </ng-container>
  
  <li>
    <a class="btn btn-primary" routerLink="/notifications"> {{'More' | translate}}...</a>
  </li>
    
  
</ul>